export default __webpack_public_path__ + "static/media/spinning-coin-1.0d74b03d.mp3";